import { type CompanyCompliance } from 'bff/src/domain/model/compliance.model';

export const faturamentoEstimadoSelectOptions: {
  value: CompanyCompliance['estimatedAnnualRevenue'] | '';
  label: string;
}[] = [
  {
    value: {
      description: 'Até R$ 360.000,00',
      maxValueCents: 36000000,
      minValueCents: 0,
    },
    label: 'Até R$ 360.000,00',
  },
  {
    value: {
      description: 'R$ 360.000,00 a R$ 500.000,00',
      maxValueCents: 50000000,
      minValueCents: 36000000,
    },
    label: 'R$ 360.000,00 a R$ 500.000,00',
  },
  {
    value: {
      description: 'R$ 500.000,00 a R$ 4.800.000,00',
      maxValueCents: 480000000,
      minValueCents: 50000000,
    },
    label: 'R$ 500.000,00 a R$ 4.800.000,00',
  },
  {
    value: {
      description: 'R$ 4.800.000,00 a R$ 100.000.000,00',
      maxValueCents: 10000000000,
      minValueCents: 480000000,
    },
    label: 'R$ 4.800.000,00 a R$ 100.000.000,00',
  },
  {
    value: {
      description: 'R$ 100.000.000,00 a R$ 300.000.000,00',
      maxValueCents: 30000000000,
      minValueCents: 10000000000,
    },
    label: 'R$ 100.000.000,00 a R$ 300.000.000,00',
  },
  {
    value: {
      description: 'R$ 300.000.000,00 a R$ 500.000.000,00',
      maxValueCents: 50000000000,
      minValueCents: 30000000000,
    },
    label: 'R$ 300.000.000,00 a R$ 500.000.000,00',
  },
  {
    value: {
      description: 'Acima de R$ 500.000.000,00',
      maxValueCents: null,
      minValueCents: 50000000000,
    },
    label: 'Acima de R$ 500.000.000,00',
  },
];

export const classificacaoEmpresaSelectOptions: {
  value: CompanyCompliance['classification'] | '';
  label: string;
}[] = [
  { value: 'PRIVATE', label: 'Privada' },
  { value: 'PUBLIC_MUNICIPAL', label: 'Público Municipal' },
  { value: 'PUBLIC_STATE', label: 'Público Estadual' },
  { value: 'PUBLIC_FEDERAL', label: 'Público Federal' },
];
